import Alert from "@mui/material/Alert";
import {useState, useEffect} from "react";

import * as Yup from "yup";
import {Form, Formik} from "formik";

import {GetProfileDetails} from "../services/auth";
import {TextFieldForm} from "../CustomComponents/inputs/TextFieldForm";
import {OTPFieldForm} from "../CustomComponents/inputs/OTPFieldForm";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import {BusinessVerificationPromptService, SendEmailChangeOtpService, SendPhoneChangeOtpService, VerifyEmailChangeOtpService, VerifyPhoneChangeOtpService} from "../services/authUpdate";

const normalizePhoneInput = (val) => {
	if (val === undefined || val === null) return "+1";
	const digits = val.toString().replace(/[^\d]/g, "");
	// always ensure it starts with country code 1
	const rest = digits.startsWith("1") ? digits.slice(1) : digits;
	return "+1" + rest;
};

const CustomBusinessVerifiedMain = ({cbAction}) => {
	const [uuid, setUuid] = useState(null);
	const [screen, setScreen] = useState("pending_verification");

	const [emailText, setEmailText] = useState(null);
	const [userDetails, setUserDetails] = useState({});
	const [successMsg, setSuccessMsg] = useState(null);
	const [errorMsg, setErrorMsg] = useState(null);
	const [isLoader, setIsLoader] = useState(false);

	const [isEmail, setIsEmail] = useState(null);
	const [isPhone, setIsPhone] = useState(null);
	const [isGoogleListing, setIsGoogleListing] = useState(null);
	const [isBusinessWebsite, setIsBusinessWebsite] = useState(null);

	useEffect(() => {
		let isMounted = true;
		const loadProfile = async () => {
			try {
				const response = await GetProfileDetails();
				if (!isMounted) return;
				if (response.status) {
					setUserDetails(response?.data);
					setUuid(response?.data?.user_uuid);
				}
			} catch (error) {
				// silently ignore
			}
		};
		loadProfile();
		return () => {
			isMounted = false;
		};
	}, []);

	const handleBusinessVerificationCheck = async (values) => {
		try {
			setErrorMsg(null);
			setSuccessMsg(null);
			setIsLoader(true);

			const response = await BusinessVerificationPromptService({
				uuid,
				email: values.businessEmail,
				phone: values.businessPhone,
				googleListing: values.googleListing,
			});

			setEmailText(response?.data?.message);

			setIsLoader(false);
			setIsPhone(values.businessPhone);
			setIsEmail(values.businessEmail);
			setIsBusinessWebsite(values?.businessWebsite);
			setIsGoogleListing(values?.googleListing);

			if (response.status === true) {
				setScreen(response?.data?.action);
				// setSuccessMsg(response.message);1
			}
			if (response.status !== true) {
				setErrorMsg(response.message);
			}
		} catch (err) {
			console.log("err", err);
		}
	};

	const sendOptEmail = async () => {
		try {
			setErrorMsg(null);
			setSuccessMsg(null);
			setIsLoader(true);
			const response = await SendEmailChangeOtpService({
				new_email: isEmail,
			});
			setIsLoader(false);
			if (response.status === true) {
				setScreen("EmailOtp");
				const message = "Please check your email for verification code.";
				setSuccessMsg(message);
			}
			if (response.status !== true) {
				setErrorMsg(response.message);
			}
		} catch (err) {
			console.log("err", err);
		}
	};

	const verifyOptEmail = async (values) => {
		try {
			setErrorMsg(null);
			setSuccessMsg(null);
			setIsLoader(true);

			const response = await VerifyEmailChangeOtpService({
				new_email: isEmail,
				googleListing: isGoogleListing,
				otp: values.otp,
			});

			setIsLoader(false);

			if (response.status === true) {
				localStorage.setItem("verified", response.data.verified);
				localStorage.setItem("trusted", response.data.trusted);
				localStorage.setItem("badge", response.data.badge || false);

				if (response.data?.action === "BusinessVerifiedSuccessfully") {
					if (cbAction) {
						cbAction("refresh");
					}
					localStorage.setItem("verified", true);
					localStorage.setItem("trusted", true);
					window.location.reload();
					setScreen("BusinessVerifiedSuccessfully");
					return;
				}

				const message = response.message;
				setSuccessMsg(message);
			}
			if (response.status !== true) {
				setErrorMsg(response.message);
			}
		} catch (err) {
			console.log("err", err);
		}
	};

	const sendOptPhone = async () => {
		try {
			setErrorMsg(null);
			setSuccessMsg(null);
			setIsLoader(true);
			const response = await SendPhoneChangeOtpService({
				new_phone: isPhone,
			});
			setIsLoader(false);
			if (response.status === true) {
				setScreen(response?.data?.action);
				const message = "You have been successfully registered.";
				setSuccessMsg(response.message);
			}
			if (response.status !== true) {
				setErrorMsg(response.message);
			}
		} catch (err) {
			console.log("err", err);
		}
	};

	const verifyOptPhone = async (values) => {
		try {
			console.log("values", values);
			setErrorMsg(null);
			setSuccessMsg(null);
			setIsLoader(true);

			const response = await VerifyPhoneChangeOtpService({
				new_phone: isPhone,
				googleListing: isGoogleListing,
				otp: values?.otp,
			});

			setIsLoader(false);

			if (response.status === true) {
				if (response.data?.action === "BusinessVerifiedSuccessfully") {
					setScreen("BusinessVerifiedSuccessfully");
					localStorage.setItem("verified", true);
					localStorage.setItem("trusted", true);
					if (cbAction) {
						cbAction("refresh");
					}
					window.location.reload();
					return;
				}
				const message = response.message;
				setSuccessMsg(message);
			}
			if (response.status !== true) {
				setErrorMsg(response.message);
			}
		} catch (err) {
			console.log("err", err);
		}
	};

	return (
		<div className="tab-content-wrapper">
			{screen === "pending_verification" && (
				<Formik
					enableReinitialize
					initialValues={{
						businessName: userDetails?.business_name || "",
						businessWebsite: userDetails?.business_website || "",
						googleListing: userDetails?.business_url || "",
						businessPhone: userDetails?.phone ? normalizePhoneInput(userDetails.phone) : "+1",
						businessEmail: userDetails?.email || "",
						businessAddress: userDetails?.address || "",
						isPhoneEditing: false,
						isEmailEditing: false,
					}}
					validationSchema={Yup.object({
						businessName: Yup.string().min(2, "Business name is required").required("Business name is required"),
						businessPhone: Yup.string()
							.transform((value) => {
								if (!value || value.trim() === "" || value.trim() === "+1") {
									return null;
								}
								return value;
							})
							.nullable()
							.matches(/^\+\d{6,15}$/, "Enter valid phone number with country code (e.g. +14155550123)"),
						businessEmail: Yup.string().email("Enter valid email").nullable(),
						googleListing: Yup.string().url("Enter valid Google business link").required("Google business listing is required"),
					})}
					onSubmit={async (values, {setSubmitting}) => {
						await handleBusinessVerificationCheck(values);
						setSubmitting(false);
					}}>
					{(props) => {
						const {handleSubmit, errors} = props;
						return (
							<Form noValidate onSubmit={handleSubmit}>
								<Stack spacing={2}>
									<Alert severity="info">
										Contractors who have an online presence, like Google Business Listing, with at least one customer review, are more trusted. Clients and other contractors will see a “trusted” badge next to
										your name. Therefore, your ratings and reviews become more authoritative.
									</Alert>
									{successMsg && <Alert severity="success">{successMsg}</Alert>}
									{errorMsg && <Alert severity="error">{errorMsg}</Alert>}
									<TextFieldForm formik={props} label="Business Name" field="businessName" placeholder="Enter your Business Name" />
									<TextFieldForm
										formik={props}
										label="Google Business Listing"
										field="googleListing"
										topSubText="(Copy and paste your Google Business Listing link here. If your business is not listed in Google, we recommend listing it)"
										placeholder="Enter your Google Business Listing"
									/>
									<TextFieldForm
										label="Business Email"
										formik={props}
										required={false}
										field="businessEmail"
										placeholder="Enter your Business Email"
										topSubText="(Preferred email: matches your website domain. E.g., your website is mybusiness.com, your email is abc@mybusiness.com)"
									/>

									<TextFieldForm
										formik={props}
										required={false}
										label="Business Phone"
										field="businessPhone"
										placeholder="Enter your Business Phone"
										topSubText="(If you don’t list an email in your Google Business Listing then, provide a cell/land line as listed in your Google Business Listing.)"
										onChange={(e) => {
											let value = e.target.value;
											if (!value.startsWith("+1")) {
												value = "+1" + value.replace(/\D/g, "");
											}
											value = "+1" + value.replace(/\D/g, "").replace(/^1/, "");
											props.setFieldValue("businessPhone", value);
										}}
									/>
									<Button variant="contained" type="submit" sx={{py: 1}} onClick={handleSubmit} disabled={isLoader}>
										Verify Business
									</Button>
								</Stack>
							</Form>
						);
					}}
				</Formik>
			)}

			{screen === "EmailMatchFound" && (
				<div>
					<Stack spacing={2} alignItems="center">
						<svg xmlns="http://www.w3.org/2000/svg" width="2.3em" height="2.3em" viewBox="0 0 16 16">
							<rect width="25" height="25" fill="none" />
							<path
								fill="#28A848"
								d="M15 2H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1M4.94 9.94l-3 3c-.12.12-.28.18-.44.18s-.32-.06-.44-.18a.63.63 0 0 1 0-.88l3-3c.24-.24.64-.24.88 0c.25.24.25.64 0 .88m10 3c-.12.12-.28.18-.44.18s-.32-.06-.44-.18l-3-3a.63.63 0 0 1 0-.88c.24-.24.64-.24.88 0l3 3c.25.24.25.64 0 .88m0-9L8.8 10.09c-.22.22-.51.33-.8.33s-.58-.11-.8-.33L1.06 3.94c-.24-.24-.24-.64 0-.88s.64-.24.88 0L8 9.12l6.06-6.06c.24-.24.64-.24.88 0c.25.24.25.64 0 .88"
							/>
						</svg>

						{/* <h2 className="form-title my-3">Email Match Found</h2>

						<h6 className="" style={{color: "#28A848", fontWeight: 800}}>
							{isEmail}
						</h6>
						<h6 className="my-3">Congrats, you have provided a matching domain-email address.</h6> */}
						{/* <h2 className="form-title my-3">Email Match Found</h2>

						<h6 className="" style={{color: "#28A848", fontWeight: 800}}>
							{isEmail}
						</h6> */}
						{/* <h6 className="my-3">{successMsg}</h6> */}

						{/* {successMsg && <Alert severity="success">{successMsg}</Alert>} */}

						<h2 className="form-title my-3">Email Match Found</h2>

						<h6 className="" style={{color: "#28A848", fontWeight: 800}}>
							{isEmail}
						</h6>

						{emailText ? <h6 className="my-3">Congrats, you have provided a matching domain-email address.</h6> : <h6 className="my-3">{emailText}</h6>}

						{errorMsg && <Alert severity="error">{errorMsg}</Alert>}
						<Stack direction="row" spacing={2}>
							<Button variant="contained" type="submit" sx={{py: 1}} onClick={sendOptEmail} disabled={isLoader} fullWidth>
								Send Code to Email
							</Button>
							<Button variant="outlined" color="dark" type="submit" sx={{py: 1}} onClick={() => setScreen("pending_verification")} disabled={isLoader}>
								Back
							</Button>
						</Stack>
					</Stack>
				</div>
			)}

			{screen === "PhoneMatchFound" && (
				<Stack spacing={2} sx={{mb: 2}} alignItems="center">
					<svg xmlns="http://www.w3.org/2000/svg" width="2.3em" height="2.3em" viewBox="0 0 1536 1536">
						<rect width="1536" height="1536" fill="none" />
						<path
							fill="#28A848"
							d="M1280 1065q0-11-2-16t-18-16.5t-40.5-25T1172 981t-45.5-25t-28.5-15q-5-3-19-13t-25-15t-21-5q-15 0-36.5 20.5t-39.5 45t-38.5 45T885 1039q-7 0-16.5-3.5T853 1029t-17-9.5t-14-8.5q-99-55-170-126.5T525 714q-2-3-8.5-14t-9.5-17t-6.5-15.5T497 651q0-13 20.5-33.5t45-38.5t45-39.5T628 503q0-10-5-21t-15-25t-13-19q-3-6-15-28.5T555 364t-26.5-47.5t-25-40.5t-16.5-18t-16-2q-48 0-101 22q-46 21-80 94.5T256 503q0 16 2.5 34t5 30.5t9 33t10 29.5t12.5 33t11 30q60 164 216.5 320.5T843 1230q6 2 30 11t33 12.5t29.5 10t33 9t30.5 5t34 2.5q57 0 130.5-34t94.5-80q22-53 22-101m256-777v960q0 119-84.5 203.5T1248 1536H288q-119 0-203.5-84.5T0 1248V288Q0 169 84.5 84.5T288 0h960q119 0 203.5 84.5T1536 288"
						/>
					</svg>
					<h2 className="form-title ">Phone Match Found</h2>
					<h6 className="" style={{color: "#28A848", fontWeight: 800}}>
						{isPhone}
					</h6>
					<h6 className="my-3">Congrats, your provided phone number matches your Google Business Listing phone number.</h6>
					{successMsg && <Alert severity="success">{successMsg}</Alert>}
					{errorMsg && <Alert severity="error">{errorMsg}</Alert>}
					<Stack direction="row" spacing={2} sx={{mb: 2}}>
						<Button variant="contained" type="submit" sx={{py: 1}} onClick={sendOptPhone} disabled={isLoader} fullWidth>
							Send Code to Phone
						</Button>
						<Button variant="outlined" color="dark" type="submit" sx={{py: 1}} onClick={() => setScreen("pending_verification")} disabled={isLoader}>
							Back
						</Button>
					</Stack>
				</Stack>
			)}

			{screen === "EmailOtp" && (
				<div className="otp-verification-section">
					<div className="otp-icon">
						<svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M22 2H2V22H22V2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M22 12H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M6 12H2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M12 6V2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M12 22V18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
					</div>
					<div className="otp-header">
						<h3 className="otp-title">Email verification</h3>
						<p className="otp-subtitle">
							We've sent a 6-digit code to <strong>{isEmail}</strong>.
						</p>
					</div>

					<Formik
						enableReinitialize
						initialValues={{
							otp: "",
						}}
						validationSchema={Yup.object({
							otp: Yup.string()
								.required("Verification code is required")
								.matches(/^\d{6}$/, "Code must be exactly 6 digits"),
						})}
						onSubmit={verifyOptEmail}>
						{(props) => {
							const {handleSubmit, errors, setFieldValue, values} = props;
							return (
								<Form noValidate>
									<Stack spacing={2} sx={{mb: 2}} alignItems="center">
										{successMsg && <Alert severity="success">{successMsg}</Alert>}
										{errorMsg && <Alert severity="error">{errorMsg}</Alert>}

										<div className="form-group">
											<label htmlFor="otp" className="form-label">
												Verification Code
											</label>
											<input
												type="text"
												id="otp"
												className="form-input otp-input"
												placeholder="123456"
												maxLength="6"
												onChange={(e) => {
													const value = e.target.value.replace(/\D/g, "");
													setFieldValue("otp", value);
												}}
												value={values.otp}
											/>
											{errors.otp && <p className="error-text">{errors.otp}</p>}
										</div>

										<Stack direction="row" spacing={2} sx={{mb: 2}} justifyContent="center" alignItems="center">
											<Button variant="contained" type="submit" sx={{py: 1}} onClick={handleSubmit} disabled={isLoader} fullWidth>
												Verify Code
											</Button>

											<Button
												variant="outlined"
												color="dark"
												type="submit"
												sx={{py: 1}}
												onClick={() => {
													setErrorMsg(null);
													setSuccessMsg(null);
													setScreen("EmailMatchFound");
												}}
												disabled={isLoader}>
												Back
											</Button>
										</Stack>
									</Stack>
								</Form>
							);
						}}
					</Formik>

					<div className="otp-actions">
						<button type="button" className="resend-btn" disabled={isLoader} onClick={sendOptEmail}>
							Didn't receive code? Resend
						</button>
					</div>
				</div>
			)}

			{screen === "PhoneOtp" && (
				<div className="otp-verification-section">
					<div className="otp-icon">
						<svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M22 2H2V22H22V2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M22 12H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M6 12H2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M12 6V2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M12 22V18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
					</div>
					<div className="otp-header">
						<h3 className="otp-title">Enter Verification Code</h3>
						<p className="otp-subtitle">
							We've sent a 6-digit code to <strong>{isPhone}</strong>
						</p>
					</div>

					<Formik
						enableReinitialize
						initialValues={{
							otp: "",
						}}
						validationSchema={Yup.object({
							otp: Yup.string()
								.required("Verification code is required")
								.matches(/^\d{6}$/, "Code must be exactly 6 digits"),
						})}
						onSubmit={verifyOptPhone}>
						{(props) => {
							const {handleSubmit, setFieldValue, dirty, values, errors} = props;
							return (
								<Form noValidate>
									<Stack spacing={2} sx={{mb: 2}} alignItems={"center"}>
										{successMsg && <Alert severity="success">{successMsg}</Alert>}
										{errorMsg && <Alert severity="error">{errorMsg}</Alert>}

										<div className="form-group">
											<label htmlFor="otp" className="form-label">
												Verification Code
											</label>
											<input
												type="text"
												id="otp"
												className="form-input otp-input"
												placeholder="123456"
												maxLength="6"
												onChange={(e) => {
													const value = e.target.value.replace(/\D/g, "");
													setFieldValue("otp", value);
												}}
												value={values.otp}
											/>
											{errors.otp && <p className="error-text">{errors.otp}</p>}
										</div>

										<Stack direction="row" spacing={2} sx={{mb: 2}} justifyContent="center" alignItems="center">
											<Button variant="contained" type="submit" sx={{py: 1}} onClick={handleSubmit} disabled={isLoader} fullWidth>
												Verify Code
											</Button>

											<Button
												variant="outlined"
												color="dark"
												type="submit"
												sx={{py: 1}}
												onClick={() => {
													setScreen("PhoneMatchFound");
													setErrorMsg(null);
													setSuccessMsg(null);
												}}
												disabled={isLoader}>
												Back
											</Button>
										</Stack>

										<div className="otp-actions">
											<button className="resend-btn" type="button" onClick={sendOptPhone}>
												Didn't receive code? Resend
											</button>
										</div>
									</Stack>
								</Form>
							);
						}}
					</Formik>
				</div>
			)}

			{screen === "BusinessVerifiedSuccessfully" && (
				<Stack spacing={2} sx={{mb: 2}} alignItems={"center"}>
					<div className="form-section text-center">
						<h2 className="form-title">Business Verified</h2>
						<p className="form-subtitle">{"Your business has been verified successfully."}</p>
						<div className="my-4 d-flex flex-column align-items-center gap-3">
							<div className="verified-badge p-3 px-4 mx-3" style={{fontSize: "18px", display: "inline-flex", alignItems: "center", gap: "10px"}}>
								<span style={{fontSize: "22px"}}>✔</span>
								<span>Business Verified</span>
							</div>
							<p className="text-muted" style={{maxWidth: 360}}>
								You’re all set. Head over to your dashboard to manage your profile, ratings, and business details.
							</p>
						</div>
					</div>
				</Stack>
			)}
		</div>
	);
};

export default CustomBusinessVerifiedMain;
